import { hot } from 'react-hot-loader/root';
import React from 'react';
import { MujiRouter, Router } from '@souche-f2e/muji';
import userRouterOptions from '../router';
const routes = [];
routes.push({
    "path": "*",
    "component": require('../pages/404').default,
});
const routerOptions = Object.assign({ routes }, userRouterOptions);
export const router = new Router(routerOptions);
const Root = () => (<MujiRouter router={router}/>);
export default hot(Root);
